import { createSlice } from '@reduxjs/toolkit';

export interface OnboardingStepState {
  inProgress: boolean;
  isDone: boolean;
  error: string;
  doRedirectFurther: boolean;
}

export interface OnboardingState {
  isDone: boolean;
  isMultipleSectorsActivated: boolean;
  isOwnDomainActivated: boolean;
}

const initialState: OnboardingState = {
  isDone: false,
  isMultipleSectorsActivated: false,
  isOwnDomainActivated: false,
};
export const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    setOnboardingBasicStateDefault: () => {
      return { ...initialState };
    },
    activateMultipleSectors: state => {
      state.isMultipleSectorsActivated = true;
    },
    deactivateMultipleSectors: state => {
      state.isMultipleSectorsActivated = false;
    },
    activateOwnDomain: state => {
      state.isOwnDomainActivated = true;
    },
    deactivateOwnDomain: state => {
      state.isOwnDomainActivated = false;
    },
    finishOnboarding: state => {
      state.isDone = true;
    },
  },
});

export const {
  setOnboardingBasicStateDefault,
  activateMultipleSectors,
  deactivateMultipleSectors,
  activateOwnDomain,
  deactivateOwnDomain,
  finishOnboarding,
} = onboardingSlice.actions;

export default onboardingSlice.reducer;
